// extracted by mini-css-extract-plugin
export default {"loginHeader":"login_loginHeader__7XlRl","loginContainer":"login_loginContainer__9EpZC","loginFormCol":"login_loginFormCol__Uflp1","loginFooter":"login_loginFooter__-9XwK"};